import { render } from "./MainDashboardView.vue?vue&type=template&id=3ae4b76e&scoped=true"
import script from "./MainDashboardView.vue?vue&type=script&lang=js"
export * from "./MainDashboardView.vue?vue&type=script&lang=js"

import "./MainDashboardView.vue?vue&type=style&index=0&id=3ae4b76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae4b76e"]])

export default __exports__